<script lang="ts">
    import { Splide, SplideSlide } from "@splidejs/svelte-splide"
    import "@splidejs/svelte-splide/css"

    import HeroSliderSlide from "./HeroSlider_slide.svelte"
    import { apiBaseOverride } from "../../store"

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase

    export let block: ContentBlockEntry
</script>

<!--
        Hero Slider
        - mit und ohne Kategorie (Dropdown-Feld)
          Kategorien: orienteering, mtb-enduro, school-sports, other-sports
        - Muss als Slider funktionieren! (Svelte)
        - Bild links oder Bild rechts (entscheidbar über Dropdown)
        
    -->

<div class="slider" data-num-slides="{block.heroSlider?.slides?.length}">
    <Splide
        options="{{
            rewind: true,
        }}"
    >
        {#each block.heroSlider?.slides || [] as slide}
            <SplideSlide>
                <HeroSliderSlide {apiBase} {slide} />
            </SplideSlide>
        {/each}
    </Splide>
</div>
